import React from "react"
import { SimpleForm, 
    TextInput, 
    BooleanInput,
    DateTimeInput,
    SaveButton, 
    DeleteButton, 
    required } from "react-admin"
import { ScreenEmpty } from "components/ui/screen"
import { useTranslate, usePermissions } from "ra-core"
import { Grid } from "@mui/material"
import { useTheme } from "@mui/material/styles"
import { CronInput } from "components/ui/forms"
import { DatagridConfigurable, TextField, DateField, 
    EditButton, WrapperField,
    BooleanField } from "react-admin"
import { CrontabField} from "components/ui/widgets"
import * as buttons from "components/ui/buttons"

interface props {
    readonly: boolean
    newRecord: boolean
}

export function ScheduleForm(props: React.PropsWithChildren<props>): JSX.Element  {
    const { readonly, newRecord } = props
    const translate = useTranslate()

    return (
        <SimpleForm toolbar={false}>
            <Grid container columnSpacing="8">
                <Grid item xs={8}>
                    <CronInput source="crontab" disabled={readonly} validate={[required()]} label={translate("resources.schedules.fields.crontab")}/>
                </Grid>
            </Grid>
            <Grid container columnSpacing="8">
                <Grid item xs={4}>
                    <BooleanInput source="active" disabled={readonly} label={translate("resources.schedules.fields.active")}/>
                </Grid>
                <Grid item xs={4}>
                    <BooleanInput source="randomize" disabled={readonly} label={translate("resources.schedules.fields.randomize")}/>
                </Grid>
            </Grid>
            <Grid container columnSpacing="8">
                <Grid item xs={4}>
                    <DateTimeInput source="date_start" disabled={readonly} label={translate("resources.schedules.fields.date_start")}/>
                </Grid>
                <Grid item xs={4}>
                    <DateTimeInput source="date_end" disabled={readonly} label={translate("resources.schedules.fields.date_end")}/>
                </Grid>
            </Grid>
            <Grid container columnSpacing="8">
                <Grid item xs={6}>
                    <TextInput source="description" disabled={readonly} label={translate("resources.schedules.fields.description")}/>
                </Grid>
            </Grid>
            <ScreenEmpty enabled={!readonly}>
                <Grid container>
                    <Grid item xs={6}>
                        <SaveButton />
                    </Grid>
                    <ScreenEmpty enabled={!newRecord}>
                        <Grid item xs={6}>
                            <DeleteButton />
                        </Grid>
                    </ScreenEmpty>
                </Grid>
            </ScreenEmpty>
        </SimpleForm>
    )
}

ScheduleForm.defaultProps = {
    readonly: false,
    newRecord: false,
}

export function ScheduleDataGrid(props: {resource: string}): JSX.Element {
    const { resource } = props
    const translate = useTranslate()
    const { permissions } = usePermissions()
    const theme = useTheme()
    const isDark = theme.palette.mode === "dark"
    return (
        <DatagridConfigurable sx={{
            "& .RaDatagrid-headerCell": { 
                fontWeight: 'bold' 
            }
        }}
        bulkActionButtons={false}
        rowSx={(record) => ({
            //className: record.enabled ? "schedule-enabled-row" : undefined,
            backgroundColor: record.enabled ? (isDark ? "#3b6d3d" : "#89fc8d") : undefined,
            "&:hover": {
                backgroundColor: record.enabled ? (isDark ? "#3b6d3d !important" : "#89fc8d !important") : undefined
            },
        })}
    >
        <TextField source="description" sortable={false}  label={translate("resources.schedules.fields.description")} />
        <CrontabField source="crontab" sortable={false}  label={translate("resources.schedules.fields.crontab")} />
        <BooleanField source="active" sortable={false}  label={translate("resources.schedules.fields.active")}/>
        <BooleanField source="randomize" sortable={false}  label={translate("resources.schedules.fields.randomize")}/>
        <DateField showTime source="date_start" sortable={false}  label={translate("resources.schedules.fields.date_start")}></DateField>
        <DateField showTime source="date_end" sortable={false}  label={translate("resources.schedules.fields.date_end")}></DateField>
        <DateField showTime source="created_at" sortable={false}  label={translate("resources.common.fields.created_at")}></DateField>
        <WrapperField label={translate("internal.actions")}>
            <EditButton label="" title={translate("ra.action.edit")} resource={resource} />
            <buttons.DeleteWithConfirmButtonX title={translate("ra.action.remove")} field="name" />
        </WrapperField>
    </DatagridConfigurable>
    )
}